// (function(window) {
//   'use strict';

//   var RecommendationTracker = {
//     apiEndpoint: 'https://5lqjijgr78.execute-api.us-east-1.amazonaws.com/track',
//     sessionId: null,
//     customerId: null,
//     debugMode: true,

//     _recentEvents: {},
//     _dedupeWindowMs: 5000,
//     _sendQueue: [],
//     _sendDelay: 500,

//     _recommendedProducts: {},
//     _recommendedVariants: {},
//     _fetchIntercepted: false,
//     _skipNextIntercept: false,

//     init: function(options) {
//       options = options || {};
//       this.sessionId = this.getOrCreateSessionId();
//       this.customerId = this.resolveCustomerId();
//       if (options.debug !== undefined) this.debugMode = options.debug;

//       this.log('🎯 Tracker initialized', { sessionId: this.sessionId, customerId: this.customerId });

//       this.interceptFetch();
//       this.initCheckoutTracking();

//       var self = this;
//       if (!this.customerId) {
//         setTimeout(function() {
//           self.customerId = self.resolveCustomerId();
//           if (self.customerId) self.log('🔄 Customer ID resolved on retry:', self.customerId);
//         }, 2000);
//       }
//     },

//     getOrCreateSessionId: function() {
//       try {
//         var sid = sessionStorage.getItem('pr_session_id');
//         if (!sid) { sid = this.generateUUID(); sessionStorage.setItem('pr_session_id', sid); }
//         return sid;
//       } catch (e) { return this.generateUUID(); }
//     },

//     resolveCustomerId: function() {
//       try {
//         if (window.__PR_CUSTOMER_ID) return window.__PR_CUSTOMER_ID.toString();
//         if (window.__st && window.__st.cid) return window.__st.cid.toString();
//         if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page) {
//           var cid = window.ShopifyAnalytics.meta.page.customerId;
//           if (cid) return cid.toString();
//         }
//         var metaTag = document.querySelector('meta[name="shopify-customer-id"]');
//         if (metaTag && metaTag.getAttribute('content')) return metaTag.getAttribute('content');
//         if (window.meta && window.meta.page && window.meta.page.customerId) return window.meta.page.customerId.toString();
//         if (window.customer && window.customer.id) return window.customer.id.toString();
//       } catch (e) {}
//       return null;
//     },

//     setCustomerId: function(id) { if (id) this.customerId = id.toString(); },

//     generateUUID: function() {
//       return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
//         var r = Math.random() * 16 | 0;
//         return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
//       });
//     },

//     getPageType: function() {
//       var path = window.location.pathname;
//       if (path.includes('/products/')) return 'product';
//       if (path.includes('/cart')) return 'cart';
//       if (path.includes('/checkouts/') || path.includes('/checkout')) return 'checkout';
//       if (path.includes('/thank_you') || path.includes('/orders/')) return 'thank_you';
//       if (path === '/' || path === '') return 'home';
//       if (path.includes('/collections/')) return 'collection';
//       return 'other';
//     },

//     getCommonData: function() {
//       this.customerId = this.resolveCustomerId();
//       return {
//         sessionId: this.sessionId,
//         customerId: this.customerId,
//         url: window.location.href,
//         referrer: document.referrer || null,
//         userAgent: navigator.userAgent,
//         timestamp: new Date().toISOString()
//       };
//     },

//     _getEventFingerprint: function(eventData) {
//       var parts = [eventData.event, eventData.widget || ''];
//       if (eventData.sourceProductId) parts.push('src:' + eventData.sourceProductId);
//       if (eventData.recommendedProductId) parts.push('rec:' + eventData.recommendedProductId);
//       if (eventData.variantId) parts.push('var:' + eventData.variantId);
//       if (eventData.cartId) parts.push('cart:' + eventData.cartId);
//       if (eventData.checkoutToken) parts.push('ck:' + eventData.checkoutToken);
//       if (eventData.orderId) parts.push('ord:' + eventData.orderId);
//       if (eventData.recommendedProductIds && eventData.recommendedProductIds.length) {
//         parts.push('ids:' + eventData.recommendedProductIds.slice().sort().join(','));
//       }
//       if (eventData.recommendedProductsPurchased && eventData.recommendedProductsPurchased.length) {
//         parts.push('purch:' + eventData.recommendedProductsPurchased.map(function(p) { return p.productId + ':' + p.variantId; }).sort().join(','));
//       }
//       return parts.join('|');
//     },

//     _isDuplicate: function(eventData) {
//       var fingerprint = this._getEventFingerprint(eventData);
//       var now = Date.now();
//       for (var key in this._recentEvents) {
//         if (now - this._recentEvents[key] > this._dedupeWindowMs) delete this._recentEvents[key];
//       }
//       if (this._recentEvents[fingerprint]) return true;
//       this._recentEvents[fingerprint] = now;
//       return false;
//     },

//     sendEvent: function(eventData) {
//       if (this._isDuplicate(eventData)) {
//         this.log('⏭️ Skipping duplicate:', eventData.event, eventData.widget || '', eventData.recommendedProductId || '');
//         return;
//       }
//       var payload = Object.assign({}, this.getCommonData(), eventData);
//       this.log('📤 Sending event:', eventData.event, payload);

//       fetch(this.apiEndpoint, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//         keepalive: true
//       })
//       .then(function(response) {
//         if (!response.ok) throw new Error('API ' + response.status);
//         return response.json();
//       })
//       .then(function(data) {
//         this.log('✅ Event sent:', eventData.event, eventData.recommendedProductId || '', data);
//       }.bind(this))
//       .catch(function(error) {
//         console.error('❌ Tracking error:', eventData.event, error);
//       });
//     },

//     sendEventDelayed: function(eventData, delayMs) {
//       var self = this;
//       if (this._isDuplicate(eventData)) {
//         this.log('⏭️ Skipping duplicate:', eventData.event, eventData.widget || '', eventData.recommendedProductId || '');
//         return;
//       }
//       setTimeout(function() {
//         var payload = Object.assign({}, self.getCommonData(), eventData);
//         self.log('📤 Sending delayed event:', eventData.event, payload);

//         fetch(self.apiEndpoint, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(payload),
//           keepalive: true
//         })
//         .then(function(response) {
//           if (!response.ok) throw new Error('API ' + response.status);
//           return response.json();
//         })
//         .then(function(data) {
//           self.log('✅ Event sent:', eventData.event, eventData.recommendedProductId || '', data);
//         })
//         .catch(function(error) {
//           console.error('❌ Tracking error:', eventData.event, error);
//         });
//       }, delayMs || 0);
//     },

//     log: function() { if (this.debugMode) console.log.apply(console, arguments); },

//     // =========================================================================
//     // PRODUCT REGISTRY
//     // =========================================================================

//     registerRecommendedProducts: function(widget, products) {
//       var self = this;
//       products.forEach(function(p) {
//         var pid = (p.productId || p.id || '').toString();
//         self._recommendedProducts[pid] = { widget: widget, title: p.title || '', price: p.price || 0, handle: p.handle || '' };
//         var vids = p.variantIds || [];
//         if (p.variantId) vids.push(p.variantId);
//         vids.forEach(function(vid) {
//           self._recommendedVariants[vid.toString()] = { productId: pid, widget: widget, title: p.title || '', price: p.price || 0 };
//         });
//       });
//       this.log('📋 Registered', products.length, 'products for', widget);
//     },

//     markManualTracking: function() {
//       this._skipNextIntercept = true;
//       var self = this;
//       setTimeout(function() { self._skipNextIntercept = false; }, 3000);
//       this.log('🔒 Manual tracking marked - fetch intercept will skip next add');
//     },

//     interceptFetch: function() {
//       if (this._fetchIntercepted) return;
//       this._fetchIntercepted = true;
//       var self = this;
//       var originalFetch = window.fetch;

//       window.fetch = function(url, options) {
//         var result = originalFetch.apply(this, arguments);

//         if (typeof url === 'string' && url.includes('/cart/add') && options && options.method && options.method.toUpperCase() === 'POST') {
//           if (self._skipNextIntercept) {
//             self.log('⏭️ Fetch intercept skipped (manual tracking)');
//             self._skipNextIntercept = false;
//             return result;
//           }

//           result.then(function(response) {
//             if (response.ok) {
//               response.clone().json().then(function(data) {
//                 self._handleCartAdd(data, options);
//               }).catch(function() {});
//             }
//           }).catch(function() {});
//         }
//         return result;
//       };

//       var origOpen = XMLHttpRequest.prototype.open;
//       var origSend = XMLHttpRequest.prototype.send;

//       XMLHttpRequest.prototype.open = function(method, url) {
//         this._prUrl = url; this._prMethod = method;
//         return origOpen.apply(this, arguments);
//       };

//       XMLHttpRequest.prototype.send = function(body) {
//         var xhr = this;
//         if (this._prUrl && this._prUrl.includes('/cart/add') && this._prMethod && this._prMethod.toUpperCase() === 'POST') {
//           if (self._skipNextIntercept) {
//             self.log('⏭️ XHR intercept skipped (manual tracking)');
//             self._skipNextIntercept = false;
//             return origSend.apply(this, arguments);
//           }
//           this.addEventListener('load', function() {
//             if (xhr.status >= 200 && xhr.status < 300) {
//               try { self._handleCartAdd(JSON.parse(xhr.responseText), { body: body }); } catch (e) {}
//             }
//           });
//         }
//         return origSend.apply(this, arguments);
//       };

//       this.log('🔗 Fetch/XHR intercepted for add-to-cart tracking');
//     },

//     _handleCartAdd: function(responseData) {
//       var self = this;
//       var addedItems = responseData.items || [responseData];

//       addedItems.forEach(function(item, index) {
//         var variantId = (item.variant_id || item.id || '').toString();
//         var productId = (item.product_id || '').toString();
//         var rec = self._recommendedVariants[variantId] || self._recommendedProducts[productId];

//         if (rec) {
//           var widget = rec.widget;
//           var price = (item.price || item.final_price || 0) / 100;

//           self.log('🎯 Recommended product added via', widget, ':', productId, variantId);

//           var delay = index * self._sendDelay;

//           self.sendEventDelayed({
//             event: 'recommendation_add_to_cart',
//             widget: widget,
//             pageType: self.getPageType(),
//             recommendedProductId: productId,
//             variantId: variantId,
//             quantity: item.quantity || 1,
//             price: price,
//             currency: 'USD',
//             cartId: self.getCartId()
//           }, delay);

//           // self.sendEventDelayed({
//           //   event: 'recommendation_purchase',
//           //   orderId: null,
//           //   currency: 'USD',
//           //   totalOrderValue: price,
//           //   attributionSource: widget,
//           //   stage: 'storefront_add_to_cart',
//           //   recommendedProductsPurchased: [{
//           //     productId: productId,
//           //     variantId: variantId,
//           //     quantity: item.quantity || 1,
//           //     price: price,
//           //     title: item.title || rec.title || '',
//           //     widget: widget
//           //   }]
//           // }, delay + 200);

//           self.storeAttribution(productId, variantId, price, item.title || rec.title || '', widget);
//         }
//       });
//     },

//     // =========================================================================
//     // ATTRIBUTION STORAGE
//     // Stores in: sessionStorage + cart attributes + cart note
//     // =========================================================================

//     storeAttribution: function(productId, variantId, price, title, widget) {
//       try {
//         var key = 'pr_rec_added_products';
//         var existing = JSON.parse(sessionStorage.getItem(key) || '[]');
//         var isDup = existing.some(function(e) { return e.productId === productId && e.variantId === variantId; });
//         if (isDup) { this.log('⏭️ Attribution already exists for', productId); return; }

//         existing.push({ productId: productId, variantId: variantId, price: price, title: title, widget: widget, addedAt: new Date().toISOString() });

//         // 1. sessionStorage
//         sessionStorage.setItem(key, JSON.stringify(existing));
//         this.log('💾 Stored attribution in sessionStorage for', productId, 'from', widget);

//         // 2. Cart attributes (bridges to checkout extension via shopify.attributes)
//         this._syncAttributionToCart(existing);

//       } catch (e) {
//         this.log('⚠️ Attribution storage error:', e);
//       }
//     },

//     _syncAttributionToCart: function(attributions) {
//       var self = this;
//       try {
//         // Write to BOTH cart attributes AND cart note for maximum compatibility
//         var attrData = JSON.stringify(attributions);

//         fetch('/cart/update.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             attributes: {
//               '_pr_rec_products': attrData,
//               '_pr_session_id': this.sessionId,
//               '_pr_customer_id': this.customerId || ''
//             }
//           })
//         })
//         .then(function(res) {
//           if (res.ok) {
//             self.log('🔗 Attribution synced to cart attributes (' + attributions.length + ' products)');
//           } else {
//             self.log('⚠️ Cart attribute sync failed: HTTP', res.status);
//           }
//         })
//         .catch(function(err) {
//           self.log('⚠️ Cart attribute sync failed:', err);
//         });
//       } catch (e) {
//         this.log('⚠️ Cart sync error:', e);
//       }
//     },

//     // =========================================================================
//     // EVENT METHODS
//     // =========================================================================

//     trackImpression: function(params) {
//       this.sendEvent({ event: 'recommendation_impression', widget: params.widget || 'pdp_recommendations', pageType: params.pageType || this.getPageType(), sourceProductId: params.sourceProductId || null, recommendedProductIds: params.recommendedProductIds || [], recommendationType: params.recommendationType || 'similar_products' });
//     },

//     trackClick: function(params) {
//       this.sendEvent({ event: 'recommendation_click', widget: params.widget || 'pdp_recommendations', pageType: params.pageType || this.getPageType(), sourceProductId: params.sourceProductId || null, recommendedProductId: params.recommendedProductId, position: params.position, recommendationType: params.recommendationType || 'similar_products' });
//     },

//     trackAddToCart: function(params) {
//       this.sendEvent({ event: 'recommendation_add_to_cart', widget: params.widget || 'cart_recommendations', pageType: params.pageType || this.getPageType(), recommendedProductId: params.recommendedProductId, variantId: params.variantId, quantity: params.quantity || 1, price: params.price, currency: params.currency || 'USD', cartId: params.cartId || this.getCartId() });
//     },

//     trackAddToCartDelayed: function(params, delayMs) {
//       this.sendEventDelayed({ event: 'recommendation_add_to_cart', widget: params.widget || 'cart_recommendations', pageType: params.pageType || this.getPageType(), recommendedProductId: params.recommendedProductId, variantId: params.variantId, quantity: params.quantity || 1, price: params.price, currency: params.currency || 'USD', cartId: params.cartId || this.getCartId() }, delayMs || 0);
//     },

//     trackViewCart: function(params) {
//       this.sendEvent({ event: 'recommendation_view_cart', widget: params.widget || 'cart_recommendations', pageType: 'cart', cartId: params.cartId || this.getCartId(), recommendedProductIds: params.recommendedProductIds || [] });
//     },

//     trackCheckoutView: function(params) {
//       this.sendEvent({ event: 'recommendation_checkout_view', widget: params.widget || 'checkout_recommendations', pageType: 'checkout', checkoutToken: params.checkoutToken || this.getCheckoutToken(), recommendedProductIds: params.recommendedProductIds || [] });
//     },

//     trackPurchase: function(params) {
//       // this.sendEvent({ event: 'recommendation_purchase', orderId: params.orderId || null, checkoutToken: params.checkoutToken || this.getCheckoutToken(), currency: params.currency || 'USD', totalOrderValue: params.totalOrderValue, attributionSource: params.attributionSource, stage: params.stage || null, recommendedProductsPurchased: params.recommendedProductsPurchased || [] });
//        return; 
//     },

//     trackPurchaseDelayed: function(params, delayMs) {
//       // this.sendEventDelayed({ event: 'recommendation_purchase', orderId: params.orderId || null, checkoutToken: params.checkoutToken || this.getCheckoutToken(), currency: params.currency || 'USD', totalOrderValue: params.totalOrderValue, attributionSource: params.attributionSource, stage: params.stage || null, recommendedProductsPurchased: params.recommendedProductsPurchased || [] }, delayMs || 0);
//        return; 
//     },

//     trackCheckoutStarted: function(params) {
//       this.sendEvent({ event: 'checkout_started', checkoutToken: params.checkoutToken || this.getCheckoutToken(), cartId: params.cartId || this.getCartId(), cartValue: params.cartValue, currency: params.currency || 'USD' });
//     },

//     trackCheckoutCompleted: function(params) {
//       this.sendEvent({ event: 'checkout_completed', orderId: params.orderId, checkoutToken: params.checkoutToken || this.getCheckoutToken(), currency: params.currency || 'USD', totalOrderValue: params.totalOrderValue, lineItems: params.lineItems || [] });
//     },

//     // =========================================================================
//     // HELPERS
//     // =========================================================================

//     getCartId: function() {
//       try {
//         if (window.Shopify && window.Shopify.cart) return window.Shopify.cart.token || null;
//         return sessionStorage.getItem('pr_cart_token') || null;
//       } catch (e) { return null; }
//     },

//     fetchCartId: function() {
//       fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
//         if (cart.token) sessionStorage.setItem('pr_cart_token', cart.token);
//       }).catch(function() {});
//     },

//     getCheckoutToken: function() {
//       var match = window.location.pathname.match(/\/checkouts\/([^\/]+)/);
//       if (match) return match[1];
//       if (window.Shopify && window.Shopify.checkout) return window.Shopify.checkout.token;
//       return null;
//     },

//     initCheckoutTracking: function() {
//       var pt = this.getPageType();
//       if (pt === 'checkout' && !sessionStorage.getItem('pr_checkout_started')) this.autoTrackCheckoutStarted();
//       if (pt === 'thank_you' && !sessionStorage.getItem('pr_order_tracked')) this.autoTrackOrderCompleted();
//       if (pt === 'product' || pt === 'cart') this.fetchCartId();
//     },

//     autoTrackCheckoutStarted: function() {
//       try {
//         if (window.Shopify && window.Shopify.checkout) {
//           var c = window.Shopify.checkout;
//           this.trackCheckoutStarted({ checkoutToken: c.token, cartValue: parseFloat(c.total_price) / 100, currency: c.currency });
//           sessionStorage.setItem('pr_checkout_started', 'true');
//         }
//       } catch (e) {}
//     },

//     autoTrackOrderCompleted: function() {
//       try {
//         if (window.Shopify && window.Shopify.checkout) {
//           var c = window.Shopify.checkout;
//           var items = (c.line_items || []).map(function(i) { return { productId: i.product_id.toString(), variantId: i.variant_id.toString(), quantity: i.quantity, price: parseFloat(i.price) / 100 }; });
//           this.trackCheckoutCompleted({ orderId: c.order_id ? c.order_id.toString() : null, checkoutToken: c.token, totalOrderValue: parseFloat(c.total_price) / 100, currency: c.currency, lineItems: items });
//           this.checkPurchaseAttribution(c);
//           sessionStorage.setItem('pr_order_tracked', 'true');
//         }
//       } catch (e) {}
//     },

//     checkPurchaseAttribution: function(checkout) {
//       try {
//         var stored = JSON.parse(sessionStorage.getItem('pr_rec_added_products') || '[]');
//         if (!stored.length) { this.log('ℹ️ No stored recommendation attributions'); return; }

//         var pIds = new Set(); var pVars = new Set();
//         (checkout.line_items || []).forEach(function(i) { pIds.add(i.product_id.toString()); pVars.add(i.variant_id.toString()); });

//         var matched = stored.filter(function(rp) { return pIds.has(rp.productId) || pVars.has(rp.variantId); });

//         if (matched.length > 0) {
//           var recP = matched.map(function(rp) {
//             var li = (checkout.line_items || []).find(function(l) { return l.product_id.toString() === rp.productId || l.variant_id.toString() === rp.variantId; });
//             return { productId: rp.productId, variantId: rp.variantId, quantity: li ? li.quantity : 1, price: li ? parseFloat(li.price) / 100 : rp.price, title: li ? li.title : rp.title, widget: rp.widget };
//           });

//           // this.trackPurchase({
//           //   orderId: checkout.order_id ? checkout.order_id.toString() : null,
//           //   checkoutToken: checkout.token,
//           //   currency: checkout.currency || 'USD',
//           //   totalOrderValue: parseFloat(checkout.total_price) / 100,
//           //   attributionSource: 'storefront_recommendations',
//           //   stage: 'order_completed',
//           //   recommendedProductsPurchased: recP
//           // });

//           // this.log('🎉 recommendation_purchase (order_completed) sent for', recP.length, 'products');
//           sessionStorage.removeItem('pr_rec_added_products');
//         }
//       } catch (e) {
//         this.log('⚠️ Purchase attribution error:', e);
//       }
//     },

//     attributeRecommendation: function(productId, source) {
//       try {
//         var a = JSON.parse(sessionStorage.getItem('pr_attributions') || '{}');
//         a[productId] = { source: source, timestamp: new Date().toISOString() };
//         sessionStorage.setItem('pr_attributions', JSON.stringify(a));
//       } catch (e) {}
//     },

//     getAttribution: function(productId) {
//       try { return JSON.parse(sessionStorage.getItem('pr_attributions') || '{}')[productId] || null; } catch (e) { return null; }
//     }
//   };

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', function() { RecommendationTracker.init(); });
//   } else {
//     RecommendationTracker.init();
//   }

//   window.RecommendationTracker = RecommendationTracker;
// })(window);


(function(window) {
  'use strict';

  var RecommendationTracker = {
    apiEndpoint: 'https://5lqjijgr78.execute-api.us-east-1.amazonaws.com/track',
    sessionId: null,
    customerId: null,
    debugMode: true,

    _recentEvents: {},
    _dedupeWindowMs: 5000,
    _sendQueue: [],
    _sendDelay: 500,

    _recommendedProducts: {},
    _recommendedVariants: {},
    _fetchIntercepted: false,
    _skipNextIntercept: false,

    init: function(options) {
      options = options || {};
      this.sessionId = this.getOrCreateSessionId();
      this.customerId = this.resolveCustomerId();
      if (options.debug !== undefined) this.debugMode = options.debug;

      this.log('🎯 Tracker initialized', { sessionId: this.sessionId, customerId: this.customerId });

      this.interceptFetch();
      this.initCheckoutTracking();

      var self = this;
      if (!this.customerId) {
        setTimeout(function() {
          self.customerId = self.resolveCustomerId();
          if (self.customerId) self.log('🔄 Customer ID resolved on retry:', self.customerId);
        }, 2000);
      }
    },

    getOrCreateSessionId: function() {
      try {
        var sid = sessionStorage.getItem('pr_session_id');
        if (!sid) { sid = this.generateUUID(); sessionStorage.setItem('pr_session_id', sid); }
        return sid;
      } catch (e) { return this.generateUUID(); }
    },

    resolveCustomerId: function() {
      try {
        if (window.__PR_CUSTOMER_ID) return window.__PR_CUSTOMER_ID.toString();
        if (window.__st && window.__st.cid) return window.__st.cid.toString();
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page) {
          var cid = window.ShopifyAnalytics.meta.page.customerId;
          if (cid) return cid.toString();
        }
        var metaTag = document.querySelector('meta[name="shopify-customer-id"]');
        if (metaTag && metaTag.getAttribute('content')) return metaTag.getAttribute('content');
        if (window.meta && window.meta.page && window.meta.page.customerId) return window.meta.page.customerId.toString();
        if (window.customer && window.customer.id) return window.customer.id.toString();
      } catch (e) {}
      return null;
    },

    setCustomerId: function(id) { if (id) this.customerId = id.toString(); },

    generateUUID: function() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    },

    getPageType: function() {
      var path = window.location.pathname;
      if (path.includes('/products/')) return 'product';
      if (path.includes('/cart')) return 'cart';
      if (path.includes('/checkouts/') || path.includes('/checkout')) return 'checkout';
      if (path.includes('/thank_you') || path.includes('/orders/')) return 'thank_you';
      if (path === '/' || path === '') return 'home';
      if (path.includes('/collections/')) return 'collection';
      return 'other';
    },

    getCommonData: function() {
      this.customerId = this.resolveCustomerId();
      return {
        sessionId: this.sessionId,
        customerId: this.customerId,
        url: window.location.href,
        referrer: document.referrer || null,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString()
      };
    },

    _getEventFingerprint: function(eventData) {
      var parts = [eventData.event, eventData.widget || ''];
      if (eventData.sourceProductId) parts.push('src:' + eventData.sourceProductId);
      if (eventData.recommendedProductId) parts.push('rec:' + eventData.recommendedProductId);
      if (eventData.variantId) parts.push('var:' + eventData.variantId);
      if (eventData.cartId) parts.push('cart:' + eventData.cartId);
      if (eventData.checkoutToken) parts.push('ck:' + eventData.checkoutToken);
      if (eventData.orderId) parts.push('ord:' + eventData.orderId);
      if (eventData.recommendedProductIds && eventData.recommendedProductIds.length) {
        parts.push('ids:' + eventData.recommendedProductIds.slice().sort().join(','));
      }
      if (eventData.recommendedProductsPurchased && eventData.recommendedProductsPurchased.length) {
        parts.push('purch:' + eventData.recommendedProductsPurchased.map(function(p) { return p.productId + ':' + p.variantId; }).sort().join(','));
      }
      return parts.join('|');
    },

    _isDuplicate: function(eventData) {
      var fingerprint = this._getEventFingerprint(eventData);
      var now = Date.now();
      for (var key in this._recentEvents) {
        if (now - this._recentEvents[key] > this._dedupeWindowMs) delete this._recentEvents[key];
      }
      if (this._recentEvents[fingerprint]) return true;
      this._recentEvents[fingerprint] = now;
      return false;
    },

    sendEvent: function(eventData) {
      if (this._isDuplicate(eventData)) {
        this.log('⏭️ Skipping duplicate:', eventData.event, eventData.widget || '', eventData.recommendedProductId || '');
        return;
      }
      var payload = Object.assign({}, this.getCommonData(), eventData);
      this.log('📤 Sending event:', eventData.event, payload);

      fetch(this.apiEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      })
      .then(function(response) {
        if (!response.ok) throw new Error('API ' + response.status);
        return response.json();
      })
      .then(function(data) {
        this.log('✅ Event sent:', eventData.event, eventData.recommendedProductId || '', data);
      }.bind(this))
      .catch(function(error) {
        console.error('❌ Tracking error:', eventData.event, error);
      });
    },

    sendEventDelayed: function(eventData, delayMs) {
      var self = this;
      if (this._isDuplicate(eventData)) {
        this.log('⏭️ Skipping duplicate:', eventData.event, eventData.widget || '', eventData.recommendedProductId || '');
        return;
      }
      setTimeout(function() {
        var payload = Object.assign({}, self.getCommonData(), eventData);
        self.log('📤 Sending delayed event:', eventData.event, payload);

        fetch(self.apiEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          keepalive: true
        })
        .then(function(response) {
          if (!response.ok) throw new Error('API ' + response.status);
          return response.json();
        })
        .then(function(data) {
          self.log('✅ Event sent:', eventData.event, eventData.recommendedProductId || '', data);
        })
        .catch(function(error) {
          console.error('❌ Tracking error:', eventData.event, error);
        });
      }, delayMs || 0);
    },

    log: function() { if (this.debugMode) console.log.apply(console, arguments); },

    // =========================================================================
    // PRODUCT REGISTRY
    // =========================================================================

    registerRecommendedProducts: function(widget, products) {
      var self = this;
      products.forEach(function(p) {
        var pid = (p.productId || p.id || '').toString();
        self._recommendedProducts[pid] = { widget: widget, title: p.title || '', price: p.price || 0, handle: p.handle || '' };
        var vids = p.variantIds || [];
        if (p.variantId) vids.push(p.variantId);
        vids.forEach(function(vid) {
          self._recommendedVariants[vid.toString()] = { productId: pid, widget: widget, title: p.title || '', price: p.price || 0 };
        });
      });
      this.log('📋 Registered', products.length, 'products for', widget);
    },

    markManualTracking: function() {
      this._skipNextIntercept = true;
      var self = this;
      setTimeout(function() { self._skipNextIntercept = false; }, 3000);
      this.log('🔒 Manual tracking marked - fetch intercept will skip next add');
    },

    interceptFetch: function() {
      if (this._fetchIntercepted) return;
      this._fetchIntercepted = true;
      var self = this;
      var originalFetch = window.fetch;

      window.fetch = function(url, options) {
        var result = originalFetch.apply(this, arguments);

        if (typeof url === 'string' && url.includes('/cart/add') && options && options.method && options.method.toUpperCase() === 'POST') {
          if (self._skipNextIntercept) {
            self.log('⏭️ Fetch intercept skipped (manual tracking)');
            self._skipNextIntercept = false;
            return result;
          }

          result.then(function(response) {
            if (response.ok) {
              response.clone().json().then(function(data) {
                self._handleCartAdd(data, options);
              }).catch(function() {});
            }
          }).catch(function() {});
        }
        return result;
      };

      var origOpen = XMLHttpRequest.prototype.open;
      var origSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function(method, url) {
        this._prUrl = url; this._prMethod = method;
        return origOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function(body) {
        var xhr = this;
        if (this._prUrl && this._prUrl.includes('/cart/add') && this._prMethod && this._prMethod.toUpperCase() === 'POST') {
          if (self._skipNextIntercept) {
            self.log('⏭️ XHR intercept skipped (manual tracking)');
            self._skipNextIntercept = false;
            return origSend.apply(this, arguments);
          }
          this.addEventListener('load', function() {
            if (xhr.status >= 200 && xhr.status < 300) {
              try { self._handleCartAdd(JSON.parse(xhr.responseText), { body: body }); } catch (e) {}
            }
          });
        }
        return origSend.apply(this, arguments);
      };

      this.log('🔗 Fetch/XHR intercepted for add-to-cart tracking');
    },

    _handleCartAdd: function(responseData) {
      var self = this;
      var addedItems = responseData.items || [responseData];

      addedItems.forEach(function(item, index) {
        var variantId = (item.variant_id || item.id || '').toString();
        var productId = (item.product_id || '').toString();
        var rec = self._recommendedVariants[variantId] || self._recommendedProducts[productId];

        if (rec) {
          var widget = rec.widget;
          var price = (item.price || item.final_price || 0) / 100;

          self.log('🎯 Recommended product added via', widget, ':', productId, variantId);

          var delay = index * self._sendDelay;

          self.sendEventDelayed({
            event: 'recommendation_add_to_cart',
            widget: widget,
            pageType: self.getPageType(),
            recommendedProductId: productId,
            variantId: variantId,
            quantity: item.quantity || 1,
            price: price,
            currency: 'USD',
            cartId: self.getCartId(),
            checkoutToken: self.getCheckoutToken()  // ← auto-resolved from URL/Shopify object
          }, delay);

          self.storeAttribution(productId, variantId, price, item.title || rec.title || '', widget);
        }
      });
    },

    // =========================================================================
    // ATTRIBUTION STORAGE
    // Stores in: sessionStorage + cart attributes
    // =========================================================================

    storeAttribution: function(productId, variantId, price, title, widget) {
      try {
        var key = 'pr_rec_added_products';
        var existing = JSON.parse(sessionStorage.getItem(key) || '[]');
        var isDup = existing.some(function(e) { return e.productId === productId && e.variantId === variantId; });
        if (isDup) { this.log('⏭️ Attribution already exists for', productId); return; }

        existing.push({ productId: productId, variantId: variantId, price: price, title: title, widget: widget, addedAt: new Date().toISOString() });

        // 1. sessionStorage
        sessionStorage.setItem(key, JSON.stringify(existing));
        this.log('💾 Stored attribution in sessionStorage for', productId, 'from', widget);

        // 2. Cart attributes
        this._syncAttributionToCart(existing);

      } catch (e) {
        this.log('⚠️ Attribution storage error:', e);
      }
    },

    _syncAttributionToCart: function(attributions) {
      var self = this;
      try {
        var attrData = JSON.stringify(attributions);

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              '_pr_rec_products': attrData,
              '_pr_session_id': this.sessionId,
              '_pr_customer_id': this.customerId || ''
            }
          })
        })
        .then(function(res) {
          if (res.ok) {
            self.log('🔗 Attribution synced to cart attributes (' + attributions.length + ' products)');
          } else {
            self.log('⚠️ Cart attribute sync failed: HTTP', res.status);
          }
        })
        .catch(function(err) {
          self.log('⚠️ Cart attribute sync failed:', err);
        });
      } catch (e) {
        this.log('⚠️ Cart sync error:', e);
      }
    },

    // =========================================================================
    // EVENT METHODS
    // =========================================================================

    trackImpression: function(params) {
      this.sendEvent({
        event: 'recommendation_impression',
        widget: params.widget || 'pdp_recommendations',
        pageType: params.pageType || this.getPageType(),
        sourceProductId: params.sourceProductId || null,
        recommendedProductIds: params.recommendedProductIds || [],
        recommendationType: params.recommendationType || 'similar_products'
      });
    },

    trackClick: function(params) {
      this.sendEvent({
        event: 'recommendation_click',
        widget: params.widget || 'pdp_recommendations',
        pageType: params.pageType || this.getPageType(),
        sourceProductId: params.sourceProductId || null,
        recommendedProductId: params.recommendedProductId,
        position: params.position,
        recommendationType: params.recommendationType || 'similar_products'
      });
    },

    // ── Main add-to-cart tracker ──
    // When calling from a checkout extension, always pass checkoutToken explicitly:
    //
    //   RecommendationTracker.trackAddToCart({
    //     widget: 'checkout_recommendations',
    //     recommendedProductId: productId,
    //     variantId: variantId,
    //     quantity: 1,
    //     price: price,
    //     checkoutToken: checkoutToken   // <-- from extension context
    //   });
    //
    trackAddToCart: function(params) {
      this.sendEvent({
        event: 'recommendation_add_to_cart',
        widget: params.widget || 'cart_recommendations',
        pageType: params.pageType || this.getPageType(),
        recommendedProductId: params.recommendedProductId,
        variantId: params.variantId,
        quantity: params.quantity || 1,
        price: params.price,
        currency: params.currency || 'USD',
        cartId: params.cartId || this.getCartId(),
        checkoutToken: params.checkoutToken || this.getCheckoutToken()  // explicit wins, fallback to auto
      });
    },

    trackAddToCartDelayed: function(params, delayMs) {
      this.sendEventDelayed({
        event: 'recommendation_add_to_cart',
        widget: params.widget || 'cart_recommendations',
        pageType: params.pageType || this.getPageType(),
        recommendedProductId: params.recommendedProductId,
        variantId: params.variantId,
        quantity: params.quantity || 1,
        price: params.price,
        currency: params.currency || 'USD',
        cartId: params.cartId || this.getCartId(),
        checkoutToken: params.checkoutToken || this.getCheckoutToken()  // explicit wins, fallback to auto
      }, delayMs || 0);
    },

    trackViewCart: function(params) {
      this.sendEvent({
        event: 'recommendation_view_cart',
        widget: params.widget || 'cart_recommendations',
        pageType: 'cart',
        cartId: params.cartId || this.getCartId(),
        recommendedProductIds: params.recommendedProductIds || []
      });
    },

    trackCheckoutView: function(params) {
      this.sendEvent({
        event: 'recommendation_checkout_view',
        widget: params.widget || 'checkout_recommendations',
        pageType: 'checkout',
        checkoutToken: params.checkoutToken || this.getCheckoutToken(),
        recommendedProductIds: params.recommendedProductIds || []
      });
    },

    trackPurchase: function(params) {
      // this.sendEvent({ event: 'recommendation_purchase', orderId: params.orderId || null, checkoutToken: params.checkoutToken || this.getCheckoutToken(), currency: params.currency || 'USD', totalOrderValue: params.totalOrderValue, attributionSource: params.attributionSource, stage: params.stage || null, recommendedProductsPurchased: params.recommendedProductsPurchased || [] });
      return;
    },

    trackPurchaseDelayed: function(params, delayMs) {
      // this.sendEventDelayed({ event: 'recommendation_purchase', orderId: params.orderId || null, checkoutToken: params.checkoutToken || this.getCheckoutToken(), currency: params.currency || 'USD', totalOrderValue: params.totalOrderValue, attributionSource: params.attributionSource, stage: params.stage || null, recommendedProductsPurchased: params.recommendedProductsPurchased || [] }, delayMs || 0);
      return;
    },

    trackCheckoutStarted: function(params) {
      this.sendEvent({
        event: 'checkout_started',
        checkoutToken: params.checkoutToken || this.getCheckoutToken(),
        cartId: params.cartId || this.getCartId(),
        cartValue: params.cartValue,
        currency: params.currency || 'USD'
      });
    },

    trackCheckoutCompleted: function(params) {
      this.sendEvent({
        event: 'checkout_completed',
        orderId: params.orderId,
        checkoutToken: params.checkoutToken || this.getCheckoutToken(),
        currency: params.currency || 'USD',
        totalOrderValue: params.totalOrderValue,
        lineItems: params.lineItems || []
      });
    },

    // =========================================================================
    // HELPERS
    // =========================================================================

    getCartId: function() {
      try {
        if (window.Shopify && window.Shopify.cart) return window.Shopify.cart.token || null;
        return sessionStorage.getItem('pr_cart_token') || null;
      } catch (e) { return null; }
    },

    fetchCartId: function() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (cart.token) sessionStorage.setItem('pr_cart_token', cart.token);
        })
        .catch(function() {});
    },

    // Auto-resolves checkout token from:
    // 1. URL pathname  e.g. /checkouts/abc123
    // 2. window.Shopify.checkout.token  (native checkout page)
    // NOTE: In checkout UI extensions (iframe context) neither will work —
    // always pass checkoutToken explicitly from the extension.
    getCheckoutToken: function() {
      try {
        var match = window.location.pathname.match(/\/checkouts\/([^\/]+)/);
        if (match) return match[1];
        if (window.Shopify && window.Shopify.checkout) return window.Shopify.checkout.token || null;
      } catch (e) {}
      return null;
    },

    initCheckoutTracking: function() {
      var pt = this.getPageType();
      if (pt === 'checkout' && !sessionStorage.getItem('pr_checkout_started')) this.autoTrackCheckoutStarted();
      if (pt === 'thank_you' && !sessionStorage.getItem('pr_order_tracked')) this.autoTrackOrderCompleted();
      if (pt === 'product' || pt === 'cart') this.fetchCartId();
    },

    autoTrackCheckoutStarted: function() {
      try {
        if (window.Shopify && window.Shopify.checkout) {
          var c = window.Shopify.checkout;
          this.trackCheckoutStarted({
            checkoutToken: c.token,
            cartValue: parseFloat(c.total_price) / 100,
            currency: c.currency
          });
          sessionStorage.setItem('pr_checkout_started', 'true');
        }
      } catch (e) {}
    },

    autoTrackOrderCompleted: function() {
      try {
        if (window.Shopify && window.Shopify.checkout) {
          var c = window.Shopify.checkout;
          var items = (c.line_items || []).map(function(i) {
            return {
              productId: i.product_id.toString(),
              variantId: i.variant_id.toString(),
              quantity: i.quantity,
              price: parseFloat(i.price) / 100
            };
          });
          this.trackCheckoutCompleted({
            orderId: c.order_id ? c.order_id.toString() : null,
            checkoutToken: c.token,
            totalOrderValue: parseFloat(c.total_price) / 100,
            currency: c.currency,
            lineItems: items
          });
          this.checkPurchaseAttribution(c);
          sessionStorage.setItem('pr_order_tracked', 'true');
        }
      } catch (e) {}
    },

    checkPurchaseAttribution: function(checkout) {
      try {
        var stored = JSON.parse(sessionStorage.getItem('pr_rec_added_products') || '[]');
        if (!stored.length) { this.log('ℹ️ No stored recommendation attributions'); return; }

        var pIds = new Set();
        var pVars = new Set();
        (checkout.line_items || []).forEach(function(i) {
          pIds.add(i.product_id.toString());
          pVars.add(i.variant_id.toString());
        });

        var matched = stored.filter(function(rp) {
          return pIds.has(rp.productId) || pVars.has(rp.variantId);
        });

        if (matched.length > 0) {
          var recP = matched.map(function(rp) {
            var li = (checkout.line_items || []).find(function(l) {
              return l.product_id.toString() === rp.productId || l.variant_id.toString() === rp.variantId;
            });
            return {
              productId: rp.productId,
              variantId: rp.variantId,
              quantity: li ? li.quantity : 1,
              price: li ? parseFloat(li.price) / 100 : rp.price,
              title: li ? li.title : rp.title,
              widget: rp.widget
            };
          });

          // trackPurchase is currently disabled — uncomment when ready
          // this.trackPurchase({ ... });

          this.log('🎉 Purchase attribution matched for', recP.length, 'products');
          sessionStorage.removeItem('pr_rec_added_products');
        }
      } catch (e) {
        this.log('⚠️ Purchase attribution error:', e);
      }
    },

    attributeRecommendation: function(productId, source) {
      try {
        var a = JSON.parse(sessionStorage.getItem('pr_attributions') || '{}');
        a[productId] = { source: source, timestamp: new Date().toISOString() };
        sessionStorage.setItem('pr_attributions', JSON.stringify(a));
      } catch (e) {}
    },

    getAttribution: function(productId) {
      try {
        return JSON.parse(sessionStorage.getItem('pr_attributions') || '{}')[productId] || null;
      } catch (e) { return null; }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { RecommendationTracker.init(); });
  } else {
    RecommendationTracker.init();
  }

  window.RecommendationTracker = RecommendationTracker;

})(window);

